const getters = {
  Authorization: state => state.user.Authorization,
  UserInfo: state => state.user.userInfo,
}
export default getters